<template>
    <v-card rounded="lg">
        <v-card-title class="d-flex justify-space-between align-center">
                <div class="text-h5 font-weight-black ps-2">{{ modalTitle }}</div>
                <v-btn
                  icon="mdi-close"
                  variant="text"
                  @click="closeModal"
                  size="x-large"
                ></v-btn>
        </v-card-title>
        <v-card-text class="overflow-y-auto">
          <v-row align="center">
            <v-col cols="auto">
              <v-icon icon="mdi-alert-outline" size="x-large"></v-icon>
            </v-col>
            <v-col>
              {{ modalMessage }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
            <v-btn class="gorate-btn-bg" rounded="xl" :text="$t('i18n.yesBtnText')" @click="confirmNavigation"></v-btn>
            <v-btn class="gorate-btn-bg-outlined" variant="outlined" rounded="xl" :text="$t('i18n.noBtnText')" @click="closeModal"></v-btn>
        </v-card-actions>
    </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'QuitFormDesignModal',
  setup () {
    const router = useRouter()
    return {
      router
    }
  },
  props: {
    modalTitle: {
      type: String,
      required: true,
      default: 'N/A'
    },
    modalMessage: {
      type: String,
      required: true,
      default: 'N/A'
    }
  },
  data () {
    return {
    }
  },
  methods: {
    confirmNavigation () {
      this.$emit('confirm-quit-navigation')
    },
    closeModal () {
      this.$emit('close-modal')
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../../styles/colors.scss";

.button-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
}
</style>
